import Hotel from '@/js/common/Domain/Entity/Hotel';

export default class HotToursHotel extends Hotel {
    initWarrantedOption() {
        const tourProducts = this.get('tourProducts');
        const warranted = tourProducts.at(0).get('tour').get('hotelAvailable') === 1;
        this.set('warranted', warranted);
    }
}